module.exports = __webpack_public_path__ + "static/35th-6ddb54e86104851e1430c0785dea0868.png";